import { FormEvent, useEffect, useState } from 'react'
// import * as Sentry from '@sentry/react'
import { App } from 'antd'
import { IMadComp, IRange, IMadText, IMadImage } from '@/models'
import { USER_API } from '@/constants/urls'
import { TYPES } from '@/constants/quiz'
import { useHttp } from '@/hooks/useHttp'
import { Button, Preloader } from '@/components/ui'
import { SelectionControls } from '../ui'
import MadRangeQuestion from './MadRangeQuestion'
import { useAppSelector } from '@/hooks/useReduxHooks'
import s from './question-types.module.scss'

interface IMadCompQuestionProps {
  question: IMadComp
  sendQuestion: (data: any) => void
  madRangeQuestions?: any
}

const MadCompQuestion = ({ question, sendQuestion, madRangeQuestions }: IMadCompQuestionProps) => {
  const [madRangeQuestion, setMadRangeQuestion] = useState({})
  const [originMadQuestion, setOriginMadQuestion] = useState<(IRange & IMadText & IMadImage) | Record<string, any>>({})
  const [selectedAnswer, setSelectedAnswer] = useState<any>()
  const token = useAppSelector((state) => state.auth.accessToken)
  const { request, requestErrors } = useHttp()
  const { message } = App.useApp()

  const getQuestion = async (questionId: number) => {
    try {
      const response = await request<any>(`${USER_API}/survey/questions/${questionId}`, 'GET', null, {
        Authorization: `Bearer ${token}`
      })
      if (response?.data) {
        setOriginMadQuestion(response.data)
      }
    } catch (e) {
      // Sentry.captureException(e)
      // Sentry.captureMessage('MadCompQuestion getQuestion USER_API/survey/questions/questionId GET')
      message.error('Произошла ошибка при получении данных')
    }
  }

  const changeInput = (answer: string) => {
    if (!selectedAnswer) {
      return setSelectedAnswer(answer)
    }
    return setSelectedAnswer((prev: any) => (prev.uuid === answer.uuid ? null : answer))
  }

  const updateMadRangeQuestion = (data: any) => setMadRangeQuestion(data)

  const onSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault()

    if (selectedAnswer) {
      const data = {
        answer_uuid: selectedAnswer.uuid,
        value: selectedAnswer.userPositionSelected
      }

      sendQuestion(data)
    } else {
      message.error('Выберите ответ')
    }
  }

  useEffect(() => {
    if (question.type === TYPES.MAD_COMP_TEXT || question.type === TYPES.MAD_COMP_IMAGE) {
      if (madRangeQuestions) {
        const currentQuestion = madRangeQuestions.find((v: any) => v?.id === question.mad_range_id)

        if (currentQuestion) {
          setMadRangeQuestion(currentQuestion)
        } else {
          getQuestion(question.mad_range_id)
        }
      } else {
        getQuestion(question.mad_range_id)
      }
    }
    // TODO: Проверить зависимости и включить правило
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [question])

  if (requestErrors) return null
  if (!Object.keys(madRangeQuestion)?.length && !Object.keys(originMadQuestion)?.length) return <Preloader />
  if (!Object.keys(madRangeQuestion)?.length && Object.keys(originMadQuestion)?.length) {
    return <MadRangeQuestion question={originMadQuestion} updateMadRangeQuestion={updateMadRangeQuestion} />
  }

  return (
    <div className={s['question-wrapper']}>
      <form className={s.question} onSubmit={onSubmit}>
        <div className={s.question__content}>
          {madRangeQuestion.answers_objects.map((answer) => (
            <SelectionControls
              key={answer.uuid}
              type='radio'
              answer={answer}
              onChange={() => changeInput(answer)}
              checked={selectedAnswer?.uuid === answer?.uuid}
            />
          ))}
        </div>
        <Button className={s['question__next-button']} type='submit'>
          Продолжить
        </Button>
      </form>
    </div>
  )
}

export default MadCompQuestion
